import { render, staticRenderFns } from "./v-goods-bang.vue?vue&type=template&id=6a1f9692&scoped=true&"
import script from "./v-goods-bang.vue?vue&type=script&lang=js&"
export * from "./v-goods-bang.vue?vue&type=script&lang=js&"
import style0 from "./v-goods-bang.vue?vue&type=style&index=0&id=6a1f9692&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f9692",
  null
  
)

export default component.exports